import React from 'react'
const Placeholder = () => {
  return <div style={{ minHeight: '37.19px' }} />
}

export default Placeholder
